import { render, staticRenderFns } from "./nava.vue?vue&type=template&id=225e1414&"
import script from "./nava.vue?vue&type=script&lang=js&"
export * from "./nava.vue?vue&type=script&lang=js&"
import style0 from "./nava.vue?vue&type=style&index=0&id=225e1414&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports